import * as React from "react"
import { useYplusPremiumAccess } from "./useYplusPremiumAccess"

interface YplusPremiumGatedProps {
    children?: React.ReactNode
}

export const YplusPremiumGated = ({ children }: YplusPremiumGatedProps) => {
    const hasPremiumAccess = useYplusPremiumAccess()
    if (!hasPremiumAccess) {
        return null
    }
    return <>{children}</>
}
